import React, { useEffect, useState } from "react";
import { IconButton, TextField, Tooltip } from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { Close, Delete, Edit, Save, ArrowUpward } from "@material-ui/icons";
import { concat, get, isEmpty, orderBy, pullAt, set, sortBy } from "lodash";
import Datetime from "react-datetime";
import { connect } from "react-redux";
import * as actions from "store/actions";
import termLogic from "../RSheets/CommonCustomElements/Term/TermLogicMain";
import { clone, formatDollar } from "shared/utility";

import Button from "components/CustomButtons/Button.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import CustomInput from "components/CustomInput/CustomInputValidate";
import NotificationAsk from "../../components/Notification/NotificationAsk";
import axios_invoice from "store/axios/axios-invoice";
import axios_pr from "store/axios/axios-pr";
import CustomPDFViewer from "../../components/CustomPDFViewer/CustomPDFViewer";
import { renderGeneratedPaymentReportLegacyHTML } from "../PaymentReports/generatedPaymentReportLegacyHTML";
import {
    getPaymentReportGenerationError,
    getSimulationValidationError,
    paymentReportPdfRequestConfig,
    paymentReportRequestConfig
} from "../PaymentReports/paymentReportGeneration";

import {
    calculateAbatedRanges,
    calculateAdjustedCommission,
    calculateEstimatedAbatedRanges,
	calculateEstimatedTermsTotal,
    getFlatFeeCommission,
    isEstimatedLease,
    isFlatFeeCommissionEnabled,
    shouldGetPaymentAmount,
    getPaymentAmount
} from "../RSheets/RSheetsLogic";

import { calculateTermsTotal, getBalanceDue, getInvoiceFormData } from "./InvoiceLogic";
import InvoiceApplyPaymentDialog from "./InvoiceApplyPaymentDialog";
import { handleError, parseFloatString } from "../../shared/utility";
import { INVOICE_STATUS } from "./InvoiceObj";

const formatDate = (date) => {
    let newDate = '';
    if (date) {
        const date_arr = date.split('T');
        if (date_arr[0]) {
            const arr = date_arr[0].split('-');
            newDate = `${arr[1]}/${arr[2]}/${arr[0]}`;
        }
    }
    return newDate;
}

const reformatDate = (date) => {
    let newDate = '';
    if (date) {
        const arr = date.split('/');
        newDate = `${arr[2]}-${arr[0]}-${arr[1]}`;
    }
    return newDate;
}

const InvoicePaymentHistory = (props) => {
    console.log('InvoicePaymentHistory', props)
    const { open, close, invoice, updateInvoicePayment } = props;
    const reportMode = !!props.reportMode;
    const [voidNotes, setVoidNotes] = useState('');
    const [isVoidingPayment, setIsVoidingPayment] = useState(false);
    const [editMode, setEditMode] = useState(null);
    const [isChanged, setIsChanged] = useState(false);
    const [localPayments, setLocalPayments] = useState([]);
    const [voidPayments, setVoidPayments] = useState([]);
    const [openedAskBeforeDelete, setOpenedAskBeforeDelete] = useState(null);
    const [openApplyPayment, setOpenApplyPayment] = useState(false);
    const [openedAskVoidInvoice, setOpenedAskVoidInvoice] = useState(false);
    const [paymentReportPdf, setPaymentReportPdf] = useState(null);
    const [loadingPaymentReportId, setLoadingPaymentReportId] = useState(null);
    const [loadingPaymentReportMessage, setLoadingPaymentReportMessage] = useState("");

    const handlePaymentFormOpen = () => setOpenApplyPayment(true);
    const handlePaymentFormClose = () => setOpenApplyPayment(false);

    const invoice_number = get(invoice, 'invoice_num', '');

    const getTotalPaid = (payments) => {
        console.log('payments', payments)
        let paid = 0;
        if (payments) {
            payments.forEach(p => {
                if (p.active === 1) {
                    if (invoice.id) {
                        if (p.invoice_id === invoice.id) {
                            if (p.payment_amount) paid = paid + parseFloat(p.payment_amount.replace(/[$,]/g, ""));
                        }
                    }
                }
            })
        }
        return paid;
    }

    useEffect(() => {
        if (props.invoicePayments) {
            if (props.invoicePayments.length === 0) {
                setLocalPayments([]);
                setVoidPayments([]);
            }
        }
        if (!isEmpty(props.invoicePayments)) {
            setLocalPayments(props.invoicePayments.filter(f => {
                if (f.active == 1) return true;
            }).map(ip => {
                const newIP = clone(ip);
                newIP.payment_date = formatDate(ip.payment_date);
                return newIP;
            }));
            setVoidPayments(props.invoicePayments.filter(f => {
                if (f.active == 0) return true;
            }).map(ip => {
                const newIP = clone(ip);
                newIP.payment_date = formatDate(ip.payment_date);
                return newIP;
            }));
        }
    }, [props.invoicePayments]);

    console.log('localPayments', localPayments, voidPayments);

    const handleChange = (field, value, id) => {
        const newPayments = clone(localPayments).map(p => {
            const np = clone(p);
            if (id === np.id) {
                np[field] = value;
            }
            return np;
        });
        setIsChanged(true);
        setLocalPayments(newPayments);
    };

    const rsData = get(invoice, "json_data", {});
    const rsType = get(invoice, 'rs_type', 0) ? 
        get(invoice, 'rs_type', 0) 
    : 
        invoice.type ? invoice.type : 0;
    const isEstimated = isEstimatedLease(rsData);

    const calcs = termLogic.calculateLeaseTerm(rsData);
    const invoice_calcs = termLogic.calculateInvoiceRows(calcs, rsData);
    console.log('invoice_calcs InvoiceFullForm', invoice_calcs);

    const payment_data = get(invoice, 'data.payment_schedule_data.data', []).map(pd => {
        console.log('pdd', pd)
        const newPD = clone(pd);
        newPD.shouldGetPaymentAmount = shouldGetPaymentAmount(newPD.option);
        newPD.amount = newPD.shouldGetPaymentAmount ? formatDollar(getPaymentAmount(rsData, newPD.option)) : newPD.value;
        newPD.amountNum = parseFloat(newPD.amount.replace(/[$,]/g, ""));
        return newPD;
    });
    console.log('payment_data', payment_data);

    let ranges = [];
    get(rsData, "lease_term", []).forEach((lt) => {
        ranges = ranges.concat(lt.ranges);
    });
    const abatedRanges = isEstimated
        ? calculateEstimatedAbatedRanges({
              lease_term: get(rsData, "lease_term", []),
              abated_rent_ranges: get(rsData, "abated_rent_ranges", []),
          })
        : calculateAbatedRanges({
              lease_term: get(rsData, "lease_term", []),
              abated: get(rsData, "abated_rent_ranges", []),
          });
    const totalRanges = isEstimated
        ? orderBy(concat(ranges, abatedRanges), ["month1", "day1"], "asc")
        : sortBy(concat(ranges, abatedRanges), (r) => new Date(r.date1));

    const total = isEstimated ? calculateEstimatedTermsTotal(totalRanges) : calculateTermsTotal(totalRanges);

    let totalCommissionBeforeAdjustment = 0;
    console.log('checking payment history', invoice, rsData, rsType);
    const flatFeeEnabled = isFlatFeeCommissionEnabled(rsData, null, rsType);
    if (flatFeeEnabled) {
        totalCommissionBeforeAdjustment = getFlatFeeCommission(rsData);
    } else {
        // let total_commission_for_this_invoice = 0;
        // payment_data.forEach(pd => {
        //     total_commission_for_this_invoice = total_commission_for_this_invoice + pd.amountNum;
        // })
        // totalCommissionBeforeAdjustment = total_commission_for_this_invoice;
        totalCommissionBeforeAdjustment = parseFloat(invoice_calcs.total_commission)
    }
    let saleCommission = 0;
    if (rsType === 4) {
        if (rsData.sale_sale_commission) {
            saleCommission = parseFloatString(rsData.sale_sale_commission);
        }
    }
    const totalCommission = rsType === 4 ? 
        saleCommission + calculateAdjustedCommission(rsData)
    :
        totalCommissionBeforeAdjustment + calculateAdjustedCommission(rsData);
    const invoice_id = get(invoice, 'id', null);
    const rsInvoiceData = getInvoiceFormData(rsData, invoice_id);
    const balanceDue = getBalanceDue({
        line_items: rsInvoiceData.data ? rsInvoiceData.data.line_items : [],
        entries: rsInvoiceData.data ? rsInvoiceData.data.entries : [],
        rsData: rsData
    }, totalCommission);
    console.log('totalCommission', totalCommission, totalCommissionBeforeAdjustment);
    const totalPaid = getTotalPaid(localPayments);

    const paidTextColor = parseFloat(totalPaid) < parseFloat(balanceDue) ? "red" : "green";

    const createPaymentReportPdf = async htmlContent => {
        const response = await axios_pr.post('/pdf', { htmlContent }, paymentReportPdfRequestConfig);
        return response.data;
    };

    const generateAndOpenPaymentReport = async payment => {
        setLoadingPaymentReportMessage("GENERATING REPORT DATA...");
        const reportResponse = await axios_pr.get(
            `/payment_report_preview?payment_id=${payment.id}&require_simulation=1`,
            paymentReportRequestConfig
        );
        const simulationValidationError = getSimulationValidationError(reportResponse.data);
        if (simulationValidationError) throw new Error(simulationValidationError);

        setLoadingPaymentReportMessage("SAVING GENERATED REPORT...");
        const htmlContent = renderGeneratedPaymentReportLegacyHTML(reportResponse.data);
        await axios_pr.post('/payment_reports2', {
            payment_id: payment.id,
            html_content: htmlContent,
            data: {
                report: reportResponse.data,
                payment_id: payment.id,
                invoice_id: get(reportResponse.data, 'json_data.invoice_id', payment.invoice_id),
                rs_id: get(reportResponse.data, 'json_data.rs_id', payment.rs_id)
            }
        }, paymentReportRequestConfig);

        setLoadingPaymentReportMessage("OPENING PAYMENT REPORT...");
        setPaymentReportPdf(await createPaymentReportPdf(htmlContent));
    };

    const openPaymentReport = async payment => {
        try {
            setLoadingPaymentReportId(payment.id);
            setLoadingPaymentReportMessage("FINDING SAVED REPORT...");
            const response = await axios_pr.get(
                `/payment_reports2?page=0&pageSize=1&payment_id=${payment.id}`,
                paymentReportRequestConfig
            );
            const reports = response.data && Array.isArray(response.data.data) ? response.data.data : [];
            const savedData = reports.length > 0 && reports[0].data ? reports[0].data : {};
            const savedHtml = savedData.html_content;

            if (savedHtml) {
                setLoadingPaymentReportMessage("OPENING SAVED REPORT...");
                setPaymentReportPdf(await createPaymentReportPdf(savedHtml));
                return;
            }

            await generateAndOpenPaymentReport(payment);
        } catch (e) {
            handleError(e);
            alert(getPaymentReportGenerationError(e));
        } finally {
            setLoadingPaymentReportId(null);
            setLoadingPaymentReportMessage("");
        }
    };

    const renderPayments = () => { 
        const renderedPayments = localPayments.filter(payment => {
            if (payment.invoice_id !== invoice.id) {
                return false;
            }
            return true;
        }).map((payment, index) => {
            const { payment_date, payment_amount, check_number, payee_name, payment_received_date, deposit_date } = payment;
            return (
                <GridItem xs={12} sm={12} md={6} key={index}>
                    <div className="boxed">
                        <GridContainer>
                            <GridItem xs={6} sm={12} md={12}>
                                <h4>Payment #{index+1}</h4>
                            </GridItem>
                            <GridItem xs={6} sm={6} md={6}>
                                {editMode === index ? (
                                    <Datetime
                                        inputProps={{
                                            placeholder: "Payment Date",
                                        }}
                                        closeOnSelect={true}
                                        onChange={(e) => {
                                            let stringDate = e;
                                            if (typeof e === "object") {
                                                stringDate = e.format("MM/DD/YYYY");
                                            }
                                            handleChange("payment_date", stringDate, payment.id);
                                        }}
                                        timeFormat={false}
                                        value={payment_date}
                                    />
                                ) : (
                                    <CustomInput label={"Payment Date"} value={payment_date} readonly readonly_show_gray />
                                )}
                            </GridItem>
                            <GridItem xs={6} sm={6} md={6}>
                                <CustomInput
                                    label={"Payment Amount"}
                                    value={payment_amount}
                                    onChange={(e) => {
                                        handleChange("payment_amount", e.target.value, payment.id);
                                    }}
                                    isDollar
                                    readonly={editMode !== index}
                                    readonly_show_gray
                                    autoFocus={editMode === index ? true : false}
                                />
                            </GridItem>
                            <GridItem xs={6} sm={6} md={6}>
                                <CustomInput
                                    label={"Check Number"}
                                    onChange={(e) => {
                                        handleChange("check_number", e.target.value, payment.id);
                                    }}
                                    value={check_number}
                                    readonly={editMode !== index}
                                    readonly_show_gray
                                />
                            </GridItem>
                            <GridItem xs={6} sm={6} md={6}>
                                <CustomInput
                                    label={"Payee Name"}
                                    onChange={(e) => {
                                        handleChange("payee_name", e.target.value, payment.id);
                                    }}
                                    value={payee_name}
                                    readonly={editMode !== index}
                                    readonly_show_gray
                                />
                            </GridItem>
                            <GridItem xs={6} sm={6} md={6}>
                                {editMode === index ? (
                                    <Datetime
                                        inputProps={{
                                            placeholder: "Deposit Date",
                                        }}
                                        closeOnSelect={true}
                                        onChange={(e) => {
                                            let stringDate = e;
                                            if (typeof e === "object") {
                                                stringDate = e.format("MM/DD/YYYY");
                                            }
                                            handleChange("deposit_date", stringDate, payment.id);
                                        }}
                                        timeFormat={false}
                                        value={deposit_date}
                                    />
                                ) : (
                                    <CustomInput label={"Deposit Date"} value={deposit_date} readonly readonly_show_gray />
                                )}
                            </GridItem>
                            <GridItem xs={6} sm={6} md={6}>
                                {editMode === index ? (
                                    <Datetime
                                        inputProps={{
                                            placeholder: "Payment Received Date",
                                        }}
                                        closeOnSelect={true}
                                        onChange={(e) => {
                                            let stringDate = e;
                                            if (typeof e === "object") {
                                                stringDate = e.format("MM/DD/YYYY");
                                            }
                                            handleChange("payment_received_date", stringDate, payment.id);
                                        }}
                                        timeFormat={false}
                                        value={payment_received_date}
                                    />
                                ) : (
                                    <CustomInput label={"Payment Received Date"} value={payment_received_date} readonly readonly_show_gray />
                                )}
                            </GridItem>
                        </GridContainer>
                        {reportMode && (
                            <div style={{ textAlign: "right", marginTop: 10 }}>
                                <Button
                                    color="rose"
                                    disabled={loadingPaymentReportId === payment.id}
                                    onClick={() => openPaymentReport(payment)}
                                >
                                    {loadingPaymentReportId === payment.id
                                        ? (loadingPaymentReportMessage || 'LOADING PAYMENT REPORT...')
                                        : 'OPEN PAYMENT REPORT'}
                                </Button>
                            </div>
                        )}
                        {!reportMode && editMode !== index && (
                            <div style={{ textAlign: "right" }}>
                                <Tooltip title="Edit">
                                    <IconButton onClick={() => {
                                        setEditMode(index);
                                    }}>
                                        <Edit />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        )}
                        {!reportMode && editMode === index && (
                            <div style={{ textAlign: "right" }}>
                                <Tooltip title="Update">
                                    <IconButton className="mr-20" onClick={() => {
                                        updateInvoicePayment({
                                            id: payment.id,
                                            invoice_id: payment.invoice_id,
                                            payment_date: reformatDate(payment_date),
                                            payment_amount,
                                            check_number,
                                            payee_name,
                                            deposit_date,
                                            payment_received_date
                                        })
                                        setEditMode(null);
                                    }}>
                                        <Save />
                                    </IconButton>
                                </Tooltip>
                                <Tooltip title="Delete">
                                    <IconButton onClick={() => {
                                        setOpenedAskBeforeDelete(payment);
                                    }}>
                                        void
                                    </IconButton>
                                </Tooltip>
                            </div>
                        )}
                    </div>
                </GridItem>
            );
        });
        if (renderedPayments.length === 0) {
            return <GridItem xs={12} md={12}><em>* No Payments *</em></GridItem>
        }
        return renderedPayments;
    };

    const renderPayments2 = () => { 
        const renderedPayments = localPayments.filter(payment => {
            if (payment.invoice_id === invoice.id) {
                return false;
            }
            return true;
        }).map((payment, index) => {
            const { payment_date, payment_amount, check_number, payee_name } = payment;
            return (
                <GridItem xs={12} sm={12} md={4} key={index}>
                    <div className="boxed">
                        <GridContainer>
                            <GridItem xs={6} sm={12} md={12}>
                                <h4>Payment #{index+1}</h4>
                                <div>Payment Date: {payment_date}</div>
                                <div>Payment Amount: {payment_amount}</div>
                                <div>Check Number: {check_number}</div>
                                <div>Payee Name: {payee_name}</div>
                                <div>
                                    <Tooltip title="Apply to this invoice">
                                        <IconButton
                                            onClick={() => {
                                                updateInvoicePayment({
                                                    id: payment.id,
                                                    invoice_id: invoice.id
                                                })
                                            }}
                                        >
                                            <ArrowUpward />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </GridItem>
            );
        });
        if (renderedPayments.length === 0) {
            return <GridItem xs={12} md={12}><em>* No Payments *</em></GridItem>
        }
        return renderedPayments;
    };

    const renderPayments3 = () => { 
        const renderedPayments = voidPayments.map((payment, index) => {
            const { payment_date, payment_amount, check_number, payee_name } = payment;
            return (
                <GridItem xs={12} sm={12} md={4} key={index}>
                    <div className="boxed">
                        <GridContainer>
                            <GridItem xs={6} sm={12} md={12}>
                                <h4>Payment #{index+1}</h4>
                                <div>Payment Date: {payment_date}</div>
                                <div>Payment Amount: {payment_amount}</div>
                                <div>Check Number: {check_number}</div>
                                <div>Payee Name: {payee_name}</div>
                                <div>Notes: {payment.notes}</div>
                            </GridItem>
                        </GridContainer>
                    </div>
                </GridItem>
            );
        });
        if (renderedPayments.length === 0) {
            return <GridItem xs={12} md={12}><em>* No Voided Payments *</em></GridItem>
        }
        return renderedPayments;
    };

    console.log('InvoicePaymentHistory', props);

    return (
        <Dialog open={open} onClose={close} keepMounted maxWidth={false} fullWidth={false}>
            <div
                className="close-btn"
                onClick={() => {
                    close();
                }}
            >
                <Close />
            </div>
            <div style={{ margin: 20, padding: 50 }}>
                <div style={{ display: "flex", justifyContent: "space-between" }}>
                    <h3>PAYMENT HISTORY FOR INVOICE #{invoice_number}</h3>
                </div>
                <div>
                    <p>Total commission due: {formatDollar(totalCommission)}</p>
                    <p style={{ color: paidTextColor }}>Total paid to date: {formatDollar(totalPaid)}</p>
                </div>
                <div>
                    {!reportMode && <Button color="primary" style={{ marginBottom: '15px', marginRight: 20 }} onClick={handlePaymentFormOpen}>
                        APPLY NEW PAYMENT
                    </Button>}
                    {!reportMode && localPayments.length === 0 && <Button color="danger" style={{ marginBottom: '15px' }} onClick={() => {
                        console.log('voiding invoice', invoice);
                        setOpenedAskVoidInvoice(true);
                    }}>
                        VOID
                    </Button>}
                </div>

                <GridContainer>
                    <GridItem xs={12} sm={12} md={12}>
                        <h4>Payments applied to this invoice</h4>
                    </GridItem>
                    {renderPayments(true)}
                    {!reportMode && <GridItem xs={12} sm={12} md={12}>
                        <hr />
                        <h4>Payments not applied to this invoice</h4>
                    </GridItem>}
                    {!reportMode && renderPayments2(false)}
                    {!reportMode && <GridItem xs={12} sm={12} md={12}>
                        <hr />
                        <h4>Voided Payments</h4>
                    </GridItem>}
                    {!reportMode && renderPayments3()}
                    <GridItem xs={12} sm={12} md={12}>
                        <Button
                            style={{ marginTop: 30, marginRight: 20 }}
                            onClick={() => {
                                close();
                            }}
                        >
                            CLOSE
                        </Button>
                    </GridItem>
                </GridContainer>
            </div>

            {openApplyPayment && (
                <InvoiceApplyPaymentDialog invoice={invoice} open={openApplyPayment} close={handlePaymentFormClose} />
            )}

            {openedAskVoidInvoice && <NotificationAsk 
                open={true}
                close={() => {
                    setOpenedAskVoidInvoice(false);
                }}
                title="Are You Sure?"
                message="Do you want to void this invoice?"
                success={async () => {
                    console.log('invoice deleting', invoice);
                    try {
                        await axios_invoice.put('/entry', {
                            id: invoice.id, 
                            status: INVOICE_STATUS.VOIDED
                        })
                        close();
                        window.location.reload();
                    } catch(e) {
                        handleError(e);
                        alert('Could not void invoice, please contact tech support if the issue persists');
                    }
                }}
            />}

            {openedAskBeforeDelete && <NotificationAsk 
                open={openedAskBeforeDelete ? true : false}
                close={() => {
                    if (isVoidingPayment) return;
                    setOpenedAskBeforeDelete(null);
                    setVoidNotes('');
                }}
                title="Are You Sure?"
                message={<div>
                    Do you want to void this payment?<br />
                    If Yes, Notes are required.<br />
                    <TextField
                        label="Void Notes"
                        multiline
                        rows={4}
                        value={voidNotes}
                        onChange={e => {
                            if (e.target.value.length <= 255) {
                            setVoidNotes(e.target.value);
                            }
                        }}
                        fullWidth
                        inputProps={{ maxLength: 255 }}
                        helperText={`${voidNotes.length}/255`}
                        margin="normal"
                    />
                </div>}
                success_button_text={isVoidingPayment ? "VOIDING..." : "VOID PAYMENT"}
                success_button_disabled={isVoidingPayment}
                success={async () => {
                    const notes = voidNotes.trim();
                    if (!notes) return alert('Please Enter Void Notes');
                    const payment = openedAskBeforeDelete;
                    setIsVoidingPayment(true);
                    try {
                        const obj = {
                            id: payment.id,
                            invoice_id: payment.invoice_id,
                            active: 0,
                            notes
                        };
                        console.log('obj', obj)
                        await axios_invoice.put('/payment', obj);
                        props.getInvoicePayments({ invoice_id: payment.invoice_id });
                        setOpenedAskBeforeDelete(null);
                        setVoidNotes('');
                    } catch(e) {
                        handleError(e);
                        const responseData = get(e, 'response.data', null);
                        const message = typeof responseData === 'string'
                            ? responseData
                            : get(responseData, 'message', 'Could not void payment. Please try again.');
                        alert(message);
                    } finally {
                        setIsVoidingPayment(false);
                    }
                }}
            />}

            {paymentReportPdf && <CustomPDFViewer
                pdfData={paymentReportPdf}
                open={true}
                close={() => {
                    setPaymentReportPdf(null);
                }}
            />}
        </Dialog>
    );
};

const mapStateToProps = (state) => {
    return {
        invoicePayments: state.invoice.invoicePayments,
        success_payments: state.invoice.success_payments,
        error_payments: state.invoice.error_payments
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getInvoicePayments: (data) => {
            dispatch(actions.getInvoicePayments(data));
        },
        createInvoicePayment: (data) => {
            dispatch(actions.createInvoicePayment(data));
        },
        updateInvoicePayment: (data) => {
            dispatch(actions.updateInvoicePayment(data));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(InvoicePaymentHistory);
